<div id="waypoint-marker-popup-container">
    <span>EDIT WAYPOINT</span>
    <h3>{{selectedWaypointOrigin}} <mat-icon>arrow_right_alt</mat-icon> {{selectedWaypointDestination}}</h3>
    <p>Drag or Delete to Change the Segment Path</p>
    <button mat-button
            (click)="deleteWaypoint()">Delete waypoint</button>

</div>